// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"655c6e22","365":"46cb95bb","373":"26e5e4be","498":"d7e330c5","634":"c53a4405","703":"2a1f3682"}[chunkId] + ".chunk.js";
};